import { useCallback } from 'react';
import { useToken } from '@/app/hooks';
import { useNavigate } from 'react-router-dom';

const useNavigationHandler = () => {
  const { token } = useToken();
  const navigate = useNavigate();

  const handleNavigation = useCallback(
    (path: string) => {
      if (!token) {
        navigate('/login');
        return;
      }

      navigate(path);
    },
    [token, navigate]
  );

  return handleNavigation;
};

export default useNavigationHandler;
